/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Word_TitleInputs */

const en_wc_vs_word_title = /** @type {(inputs: Wc_Vs_Word_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where Word is still better`)
};

/**
* | output |
* | --- |
* | "Where Word is still better" |
*
* @param {Wc_Vs_Word_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_word_title = /** @type {((inputs?: Wc_Vs_Word_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Word_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_word_title(inputs)
});
export { wc_vs_word_title as "wc.vs.word_title" }